import React from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import AllItems from "../components/Views/AllItems.jsx";
import AddForm from "../components/Views/AddForm.jsx";
import ViewForm from "../components/Views/ViewForm.jsx";
import EditForm from "../components/Views/EditForm.jsx";
import Container from "./Container.jsx";
import { editButtonTheme as back } from "../config/theme";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";

class PaymentMethodsContainer extends Container {
    constructor(props) {
        super(props);
        this.initDatasource("payment_methods");
    }

    render = () => {
        const notPermitted = this.checkAvailability();

        if (notPermitted) {
            return <Route render={() => <Redirect to="/" replace />} />;
        }

        if (this.props.user) {
            const userType = this.props.user.type;

            if (userType !== "admin") {
                return (
                    <Route render={() => <Redirect to="/hotels" replace />} />
                );
            }
        }

        const { mainId } = { ...this.props.match.params };
        const fields = this.datasource.getSchemaFields();
        const routes = this.datasource.routes();
        const relations = this.datasource.getSchemaRelations();
        const relationsDataSource = this.datasource.relations;
        const controlButtons = this.props.baseEntity && {
            type: back,
            icon: <ArrowBackIcon />,
            caption: "Вернуться",
            link: this.getBackLink(),
        };

        return (
            <Switch>
                <Route path={routes.home} exact>
                    <AllItems
                        title={"Способы оплаты"}
                        columns={{
                            id: "Id",
                            name: "Наименование",
                            active: "Активен",
                            card_guarantee: "Требуется авторизация карты",
                            payment_required: "Требуется предоплата",
                            scope_individual: "Для индивидуальных гостей",
                            scope_partners: "Для партнеров",
                            scope_channel: "Для каналов продаж",
                        }}
                        controlButtons={controlButtons}
                        addRoute={routes.add}
                        initAction={this.getAllItems}
                        items={this.state.AllItems}
                        loading={this.state.loading}
                        removeAction={this.removeItem}
                        toggleAction={this.toggleItem}
                        viewAction={this.getViewLink}
                        editAction={this.getEditLink}
                    />
                </Route>
                <Route path={routes.add()} exact>
                    <AddForm
                        title={"Новый способ оплаты"}
                        loading={this.state.loading}
                        fields={fields}
                        initAction={this.initCurrentItem}
                        item={this.state.currentItem}
                        getBackLink={this.getBackLink}
                        submitAction={this.addItem}
                        fieldUpdateHandler={this.setFieldValue}
                        errorFields={this.state.error}
                        relations={relations}
                        relationsDataSource={relationsDataSource}
                        setRelationsValue={this.setRelationsValue}
                    />
                </Route>
                <Route path={routes.view(":id")} exact key="view">
                    <ViewForm
                        title="Просмотр способа оплаты"
                        loading={this.state.loading}
                        fields={fields}
                        initAction={this.getItem}
                        item={this.state.currentItem}
                        getBackLink={this.getBackLink}
                        getHotelUsersLink={this.getHotelUsersLink}
                    />
                </Route>
                <Route path={routes.edit(":id")} exact key="edit">
                    <EditForm
                        loading={this.state.loading}
                        item={this.state.currentItem}
                        fields={fields}
                        errorFields={this.state.error}
                        initAction={this.getItem}
                        submitAction={this.updateItem}
                        getBackLink={this.getBackLink}
                        fieldUpdateHandler={this.setFieldValue}
                    />
                </Route>
            </Switch>
        );
    };
}

export default PaymentMethodsContainer;
